import API from './API.js';
export default class Video extends API {
    constructor(videoGalleryId) {
         super(`video-gallery/${videoGalleryId}/videos`)
    }

}
